import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lems-v1/images/close-black-icon.svg'


const _hoisted_1 = {
  class: "modal-dialog leaveModal",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "leaveModal-header" }
const _hoisted_4 = { class: "leaveModal-btm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "deleteProfileimg",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true",
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleModalClick && _ctx.handleModalClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "close",
            id: "deleteProfileimgClose",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            "aria-label": "Close"
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)
          ]))]),
          _createElementVNode("h1", null, _toDisplayString(_ctx.constants.DELETE_PICTURE_TEXT), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            "aria-label": "Close",
            class: "v1-button-outline-black",
            id: "deleteProfileCancel"
          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
            class: "v1-button-outline",
            id: "deleteProfileYes"
          }, _toDisplayString(_ctx.constants.YES_LINK), 1)
        ])
      ])
    ])
  ]))
}